angular.module('unergie.main')
.directive('validationPerimeter', ($filter, DataAccess, PrmValidationConstants, PrmUtilsService, AlertManager, MetaWatcher, BoFeaturesService, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/perimeterValidation/validationPerimeter/validationPerimeter.html',
        scope: {
            perimeter: '=',
            showValidation: '=',
            accounts: '=',
        },
        link($scope) {
            const validationFeatures = BoFeaturesService.getModuleFeatures('validation')
            $scope.canMigratePDL = validationFeatures.canMigratePDL
            $scope.isPrmValid = PrmUtilsService.isPrmValid

            $scope.isEnedisKo = (prm) => PrmValidationConstants.KO_ENEDIS_STATUSES.includes(prm.enedis_status)

            $scope.getBrandClass = (item) => {
                if (item.cluster && item.cluster.brand) {
                    if (!item.cluster.existing) {
                        return 'red'
                    } else if ((!_.get(item, 'previous.cluster.brand') || item.cluster.brand === item.previous.cluster.brand) && item.cluster.complete) {
                        return 'green'
                    } else if (_.get(item, 'previous.cluster.brand') && item.cluster.brand !== item.previous.cluster.brand) {
                        return 'deep-blue'
                    } else if ((!_.get(item, 'previous.cluster.brand') || item.cluster.brand === item.previous.cluster.brand) && !item.cluster.complete) {
                        return 'orange'
                    }
                }
            }

            $scope.checkDifference = (pdl, fields) => {
                if (pdl.previous) {
                    const fArray = _.isArray(fields) ? fields : [fields]
                    return _.some(fArray, (f) => (pdl[f] || pdl.previous[f]) && `${_.get(pdl, f)}` !== `${_.get(pdl.previous, f)}`)
                }
                return false
            }

            $scope.anySet = (item, fields) => {
                if (item) {
                    return _.some(fields, (f) => item[f])
                }
                return false
            }

            $scope.computeValidationStatusClass = (item) => {
                if (item.status === 'AFFECTED') {
                    if (item.cluster && item.cluster.brand) {
                        return 'green'
                    }
                    return 'red'
                }
                return 'orange'
            }

            $scope.migrationTemplate = {
                id_managed_account: undefined,
            }

            $scope.migrationFields = {
                label: {
                    label: () => `<span class="red">Cela supprimera les informations mises à jour sur le point.</span>`,
                    type: 'label',
                },
                id_managed_account: {
                    label: 'Compte',
                    type: 'typeahead',
                    size: 45,
                    required: true,
                    enum: $scope.accounts,
                },
            }

            $scope.prepareMigration = (pdl) => {
                $scope.migrationTemplate.id_managed_account = pdl.id_managed_account
            }

            $scope.migrate = (pdl) => {
                if (pdl.id_managed_account === $scope.migrationTemplate.id_managed_account) {
                    return AlertManager.error(`Même compte`)
                }
                pdl.migrating = true
                return DataAccess.migrateValidationPerimeterToAccount({ id: pdl.id, id_managed_account: $scope.migrationTemplate.id_managed_account }, {}).$promise
                .then((result) => {
                    AlertManager.success(`PDL déplacé`, 10000)
                    MetaWatcher.notif('MNG_ACCOUNT_CHANGED')
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    pdl.migrating = false
                })
            }
        },
    })
)
